module.exports = {
    //首页
    home: {
        list: '/online/notice/index', //首页政策法规
        noticeDetail: '/online/notice/detail' //首页政策法规详情
    },
    login: {
        captchaImage: '/captchaImage',//生成验证码
        getCaptcha: '/online/apply/getCaptcha',//生成验证码
        login: '/online/applyfor/login',//登录
        logout: '/online/logout',//退出登录
        chooseSpace: '/online/applyfor/chooseSpace',//选择企业/个人
    },
    register: {
        //在线申领
        faceIdentityCheck: '/online/apply/faceIdentityCheck',//校验人脸识别结果
        upload: '/online/apply/upload',//图片上传
        submitPersonalSeal: '/online/apply/personal/submitPersonalSeal',//在线申请个人印章
        sendSMSCode: '/online/apply/sendSMSCode',//发送手机验证码
        verifySMSCode: '/online/apply/verifySMSCode',//验证手机验证码
        initFace: '/online/apply/initFace',//初始化人脸识别
        setPersonalPin: '/online/apply/personal/setPersonalPin',//设置独立签署密码
        getProductsInfo: '/online/apply/getProductsInfo',//获取商品信息
        createOrder: '/online/apply/createOrder',//创建订单信息
        doTrackTrade: '/online/apply/doTrackTrade',//订单回调
        submitBusinessSeal: '/online/apply/business/submitBusinessSeal',//在线申请企业印章
        genSealImg: '/online/apply/business/genSealImg',//生成印章图片
        getSealType: '/online/apply/business/getSealType',//获取印章类型
        verifySmsCode: '/online/apply/verifySmsCode',//找回密码验证手机验证码
        retrievePassword: '/online/apply/retrievePassword',//找回密码
        consigneeInfo: '/online/apply/business/consigneeInfo',
        downAuth: '/online/apply/downloadAuthTemplate',//下载授权书
    },
    user: {
        deactivateSeal: '/online/eseal/deactivateSeal',//印章注销
        getInfo: '/online/eseal/index/getInfo',//获取企业、个人信息
        getESealInfo: '/online/eseal/getESealInfo',//获取印章信息
        getEsealImg: '/online/eseal/index/getEsealImg',//获取企业、个人印章图片
        getEsealProof: '/online/eseal/getEsealProof',//获取备案证明
        getSealType: '/online/apply/getSealType',//获取印章类型
        getSignatureLog: '/online/eseal/signature/getSignatureLog',//获取印章列表
        changePinCode: '/online/eseal/onlineUser/changePinCode',//修改独立签署密码
        renewSeal: '/online/eseal/renewSeal',//续期印章
        downProof: '/online/eseal/getEsealProof',//下载印章备案证明
        retrievePincode: '/online/eseal/onlineUser/retrievePinCode',//找回签署密码
        sendSMSCode: '/online/eseal/onlineUser/sendSMSCode',//发送验证码
        genSealImg: '/online/apply/personal/genSealImg',//生成个人签名图
        changePassword: '/online/eseal/onlineUser/changePassword',//修改登录密码
        getApplyESeal: '/online/eseal/getApplyESeal',//应用授权查询
        createApplyAuthOrder: '/online/eseal/createApplyAuthOrder',//创建应用授权订单
        getApplyAuthProduct: '/online/apply/getApplyAuthProduct',//获取应用授权商品信息
        getApplyAuthInfoByUKeySN: '/online/eseal/getApplyAuthInfoByUKeySN',//根据UKEY序列码获取授权信息
        onlineTradeInfo: '/online/onlineTradeInfo/list',//查询订单列表
        getServiceInfo: '/online/eseal/getServiceInfo',//获取客户服务信息
        updateServiceInfo: '/online/eseal/updateServiceInfo',//修改客户服务信息
    },
    handWriting: {
        getInfo: '/api/v1/plugin/handwriting/regist/page/query',//通过token获取签名人信息
        verifySignature: '/api/v1/plugin/handwriting/regist/page/submit',//提交签名后的图片
    },
    transfer: {
        getToken: '/api/v1/online/getToken',//通过token获取签名人信息
    },
    authentication: {
        insertBusiness: '/online/eseal/insertBusiness',//个人账户新增企业接口
        getBusinessList: '/online/eseal/index/getBusinessList',//更新账号用户信息
        getLegalPersonByCreditCode: '/online/apply/getLegalPersonByCreditCode',//获取法人信息
    },
    customerEnterprise: {
        captchaImage: '/captchaImage',//生成验证码
        login: '/kq/login',  //刻企登录
        chooseKqDept: '/kq/chooseKqDept',  //刻企登录
        getInfo: '/kq/index/getInfo',  //获取刻企基本信息
        getOnlineUserInfo: '/kq/index/getOnlineUserInfo',  //根据信用代码获取基本信息
        submitBusinessSeal: '/kq/index/business/submitBusinessSeal',  //提交企业印章申请信息
        createOrder: '/kq/index/createOrder',  //创建订单信息
        getSecretSealImage: '/kq/index/getSecretSealImage',  //获取电子印章图片
        getMakeSealList: '/kq/index/getMakeSealList',  //获取制作印章信息
        doMakeESealNow: '/kq/index/doMakeESealNow',  //制作绑定UKey接口
        deactivateSeal: '/kq/index/deactivateSeal',  //注销印章
        deleteSealById: '/kq/index/deleteSealById',  //删除印章
        getTradeInfoList: '/kq/index/getTradeInfoList',  //获取制作印章订单信息
        getConsigneeInfo: '/kq/index/getConsigneeInfo',  //获取收货地址信息
        deliver: '/kq/index/deliver',  //发货
        getTradeInfo: '/kq/index/getTradeInfo',  //获取订单详情
        annualSurvey: '/kq/index/annualSurvey',  //年检
        getEncryptStr: '/online/apply/getEncryptStr',  //获取加密字符串
        getApplyAuthInfo: '/kq/index/getApplyAuthInfo',  //获取加密字符串
        addApplyAuthInfo: '/kq/index/addApplyAuthInfo',  //获取加密字符串
        changeKqPassword: '/kq/changeKqPassword',  //修改密码
        getInvoiceOrderList: '/kq/index/getInvoiceOrderList',  //发票列表
        handleInvoice: '/kq/index/handleInvoice',  //开发票
        getInvoiceInfo: '/kq/index/getInvoiceInfo/',  //查看发票信息
        refund: '/kq/index/refund',  //退款
        doMakeNowSeal: '/kq/index/doMakeNowSeal',  //管理员制章接口 参数:id
        getDataInfo: '/kq/index/getDataInfo',  //管理员查看印模接口 参数:id
        replaceSealMark: '/kq/index/replaceSealMark',  //管理员替换服务器印模图片 参数:id sealMarkId
        getPhysicalSealOrderList: '/kq/index/getPhysicalSealOrderList',  //获取物理印章订单
        getPhysicalSealOrderDetail: '/kq/index/getPhysicalSealOrderDetail',  //获取物理印章订单详情 参数 tradeNo
        getChildDeptList: '/kq/index/getChildDeptList',  //获取子部门列表
        issueSealCount: '/kq/index/issueSealCount',  //下发刻章次数
        addChildDept: '/kq/index/addChildDept',  //新增代理商下属部门
        getKqBuyCloudSealService: '/kq/index/getKqBuyCloudSealService',  //商品中心
        getCustomerServiceList: '/online/customerService/list', //获取列表
        getCustomerService: '/online/customerService', //添加
        getOnlineProductInfoList: '/kq/index/getProductServiceList'
    },
    invoice: {
        getInvoiceHeader: '/online/eseal/getInvoiceHeader',  //获取发票抬头信息
        insertInvoiceHeader: '/online/eseal/insertInvoiceHeader',  //新增发票抬头信息
        updateInvoiceHeader: '/online/eseal/updateInvoiceHeader',  //修改发票抬头信息
        applyInvoice: '/online/eseal/applyInvoice',  //修改发票抬头信息
        getInvoiceImg: '/online/eseal/getInvoice/',  //查看发票图片
    },
    H5: {
        apply: '/api/v1/physical/seal/apply',  //提交信息
        goods: '/api/v1/physical/seal/goods',  //商品信息
        createApply: '/api/v1/physical/seal/createApply',  //经办人认证
        queryPayStatus: '/api/v1/physical/seal/queryPayStatus',  //是否支付查询
        recreateApply: '/api/v1/physical/seal/reCreateApply',  //再次申请
        queryApplyList: '/api/v1/physical/seal/queryApplyList',  //订单列表
        queryApplyDetail: '/api/v1/physical/seal/queryApplyDetail',  //订单列表
        verifyFacial: '/api/v1/physical/seal/verifyFacial',  //人脸识别验证
    },
    digitalCertificate: {
        initPage: '/api/v1/certApply/initPage', //初始化申请页面数据接口
        downApplyFile: '/api/v1/certApply/downApplyFile', //获取申请文件
    }


}
